import { ComputedRef } from 'vue'

import { TestType } from '@/domain/value_objects/judge/TestType'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { EditorPageStateViewModel } from '@/presentation/viewmodels/editor/editorPageStateViewModel'
import { FreeSpaceStateViewModel } from '@/presentation/viewmodels/freeSpace/freeSpaceStateViewModel'
import { JudgeStateViewModel } from '@/presentation/viewmodels/judge/judgeStateViewModel'
import { PostTestSubmissionViewModel } from '@/presentation/viewmodels/judge/postTestSubmissionViewModel'
import { NotificationViewModel } from '@/presentation/viewmodels/notification/notificationViewModel'
import { store } from '@/store'

export class PostTestSubmissionPresenter {
  private viewModel: PostTestSubmissionViewModel
  private editorPageStateViewModel: EditorPageStateViewModel
  private freeSpaceStateViewModel: FreeSpaceStateViewModel
  private notificationViewModel: NotificationViewModel
  private judgeStateViewModel: JudgeStateViewModel

  constructor(
    viewModel: PostTestSubmissionViewModel,
    editorPageStateViewModel: EditorPageStateViewModel = new EditorPageStateViewModel(),
    freeSpaceStateViewModel: FreeSpaceStateViewModel = new FreeSpaceStateViewModel(),
    notificationViewModel: NotificationViewModel = new NotificationViewModel(store),
    judgeStateViewModel: JudgeStateViewModel = new JudgeStateViewModel()
  ) {
    this.viewModel = viewModel
    this.editorPageStateViewModel = editorPageStateViewModel
    this.freeSpaceStateViewModel = freeSpaceStateViewModel
    this.notificationViewModel = notificationViewModel
    this.judgeStateViewModel = judgeStateViewModel
  }

  get judgeToken(): ComputedRef<string> {
    return this.viewModel.judgeToken
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<string | null> {
    return this.viewModel.error
  }

  async postTestSubmission(
    problemId: string,
    programLanguage: ProgramLanguageType,
    sourceCode: string,
    type: TestType
  ): Promise<void> {
    // エラーを非表示
    this.editorPageStateViewModel.setIsErrorShow(false)
    this.freeSpaceStateViewModel.setIsErrorShow(false)

    // 通知を表示
    await this.notificationViewModel.openRunning({
      type: 'Run',
      showFreeSpaceModal: type == 'completelyFreespace' ? true : false,
      problemId
    })

    // テスト実行中の状態に変更
    await this.judgeStateViewModel.setIsTestNotificationLoading(true)
    await this.judgeStateViewModel.setIsTestLoading(true)

    await this.viewModel.postTestSubmission(problemId, programLanguage, sourceCode, type)
  }
}
